module.exports = __webpack_public_path__ + "static/media/cert_84.aa803188.jpg";